/**
 * @callback requestCallback
 */
import {
  GlobalMessageBox,
  messageSettings,
} from "../Components/Dialogs/GlobalMessageBox";
import {
  GlobalConfirmBox,
  ConfirmSettings,
} from "../Components/Dialogs/GlobalConfirmBox";
import { hookstate } from "@hookstate/core";
import { getThemeConfig } from "../Basic/ThemeConfig";
import Cookies from "universal-cookie";
import { getCookieSetOptions } from "../Basic/BasicData";
const ServerConfig = {
  Me: "PMO",
  backEndUrl: process.env.REACT_APP_API_URL,
  Bridge_backEndUrl: process.env.REACT_APP_Bridge_API_URL,
  GcisUrl: process.env.REACT_APP_GCIS_API_URL,
  /**@type {boolean} */
  cacheSettingLoaded: false,
  /**@type {number} */
  cacheExpire: 0,
  /**@type {number} */
  countDown: 0,
  /**@type {any} */
  BasicData: {
    token: "",
    userId: "",
    userName: "",
    orgId: "",
    orgName: "",
    email: "",
    userType: "",
    roles: [],
    allRoles: [],
    agentId: "",
    identityType: ""
  },
  defaultPageSize: 20,
};

const _globalState = {
  globalMessageBoxSettings: messageSettings,
  globalConfirmBoxSettings: ConfirmSettings,
  globalServerConfig: ServerConfig,
};

/**
 * 利用hookstate套件管理globaleState
 */
export const globalState = hookstate(_globalState);

/**
 * @function showGlobalMessageBox
 * @param {string} message 訊息內容
 * @param {requestCallback} [callback] 按下確認後回呼的事件
 * @description 利用globalState顯示全域訊息框
 * @example
 * <caption>使用方式1:</caption>
 * let message="訊息";
 * showGlobalMessageBox(message)
 * @example
 * <caption>使用方式2:</caption>
 * let message="訊息";
 * let callback=()=>{};
 * showGlobalMessageBox(message)
 * @see globalState 參閱globalState
 * @author Peter.Pang <peter_pang@gss.com.tw>
 */
export const showGlobalMessageBox = (message, callback, buttonVisible = true) => {
  globalState.globalMessageBoxSettings.set({
    visible: true,
    message: message,
    okText: globalState.globalMessageBoxSettings.get().okText,
    onOkAction:
      typeof callback == "function" ? () => callback() : () => { }, //利用空的function覆蓋
    buttonVisible: buttonVisible
  });
};


/**
 * 更新提示訊息
 * @param {*} message 顯示訊息
 * @param {*} callback callback
 * @param {*} buttonVisible 是否顯示確認按鈕
 */
export const updateMessageBox = (message, callback = null, buttonVisible = false) => {
  globalState.globalMessageBoxSettings.set({
    visible: true,
    buttonVisible: buttonVisible,
    message: message,
    okText: globalState.globalMessageBoxSettings.get().okText,
    onOkAction:
      typeof callback == "function" ? () => callback() : () => { }, //利用空的function覆蓋
  })
}

/**
 * @function showGlobalConfirmBox
 * @param {string} message 訊息內容
 * @param {requestCallback|Promise<any>} [OkActionCallback] 按下確認後回呼的事件
 * @param {requestCallback} [OkCancelCallback] 按下取消後回呼的事件
 * @description 利用globalState顯示全域確認框
 * @example
 * <caption>使用方式1:</caption>
 * let message="訊息";
 * showGlobalConfirmBox(message)
 * @example
 * <caption>使用方式2:</caption>
 * let message="訊息";
 * let OkActionCallback=()=>{};
 * let OkCancelCallback=()=>{};
 * showGlobalConfirmBox(message,OkActionCallback,OkCancelCallback)
 * @see globalState 參閱globalState
 * @author Peter.Pang <peter_pang@gss.com.tw>
 */
export const showGlobalConfirmBox = (
  message,
  OkActionCallback,
  OkCancelCallback
) => {
  globalState.globalConfirmBoxSettings.set({
    visible: true,
    message: message,
    okText: globalState.globalConfirmBoxSettings.get().okText,
    onOkAction:
      typeof OkActionCallback == "function"
        ? () => OkActionCallback()
        : () => { },
    onCancelAction:
      typeof OkCancelCallback == "function"
        ? () => OkCancelCallback()
        : () => { },
  });
};

export const setGlobalCountDown = (c) => {
  globalState.globalServerConfig.countDown.set(c);
};

export const getGlobalServerConfig = () => {
  return globalState.globalServerConfig;
};

export const resetGlobalServerConfig = () => {
  globalState.globalServerConfig.cacheSettingLoaded.set(false);
  globalState.globalServerConfig.BasicData.set({
    token: "",
    userId: "",
    userName: "",
    orgId: "",
    orgName: "",
    email: "",
    userType: "",
    agentId: "",
    roles: [],
    allRoles: [],
    identityType: ""
  });
};

/**
 * 切換網站樣式
 * @param {string} themeName
 */
export const setTheme = (themeName) => {
  let themeConfig = getThemeConfig();

  themeConfig.forEach((t) => {
    document.documentElement.style.setProperty(
      `--selected-${t}`,
      `var(--${themeName}-${t})`
    );
  });
  SetThemeCookie(themeName);
};

export const getThemeCookie = () => {
  let cookies = new Cookies().getAll();
  if (cookies.hasOwnProperty("theme")) return new Cookies().get("theme");

  return null;
};

const SetThemeCookie = (themeName) => {
  let cookieExpireDate = new Date();
  cookieExpireDate.setDate(cookieExpireDate.getDate() + 30);
  new Cookies().set(
    "theme",
    themeName,
    getCookieSetOptions(process.env.REACT_APP_COOKIE_PATH, cookieExpireDate)
  );
};

export { GlobalMessageBox, GlobalConfirmBox };
